/**
 * Carrying a creator back to what they were doing.
 *
 * Payout details are a detour: a creator goes to add them because an invoice
 * asked for them, and today the save leaves them on a settings page with the
 * invoice abandoned. These tag the detour with where it came from, so the
 * page that ends it can offer the way back.
 */

export const RETURN_PARAM = 'next';

/** Creator pages only. Anything else is either staff or not ours. */
const ALLOWED_PREFIX = '/influencer/';

/** `destination` with a `next` pointing at `comeBackTo`. */
export function withReturnTo(destination, comeBackTo) {
  if (!comeBackTo) return destination;
  const joiner = destination.includes('?') ? '&' : '?';
  return `${destination}${joiner}${RETURN_PARAM}=${encodeURIComponent(comeBackTo)}`;
}

/**
 * The path to return to, or null when there isn't a safe one.
 *
 * Only same-site creator paths are accepted. A `next` that points at another
 * origin would let a crafted link bounce a signed-in creator off the product
 * immediately after they hand over their bank details — which is exactly the
 * shape of a phishing hand-off.
 */
export function readReturnTo(search) {
  let value = null;
  try {
    value = new URLSearchParams(search || '').get(RETURN_PARAM);
  } catch (e) {
    return null;
  }
  if (!value) return null;

  // "//host" is protocol-relative and leaves the site; "scheme:" does too.
  if (value.startsWith('//') || /^[a-z][a-z0-9+.-]*:/i.test(value)) return null;
  if (!value.startsWith(ALLOWED_PREFIX)) return null;

  return value;
}
